import React from 'react';
import { ClickOut } from '..';
import Wrapper, { SubButton } from './style';

const Index = (props) => {
  const { listOfSubBtn, isShow, setIsShow } = props;

  const onClickOutside = () => {
    setIsShow(false);
  };

  if (isShow) {
    return (
      <ClickOut onClickOutside={onClickOutside}>
        <Wrapper>
          {listOfSubBtn.map((item) => {
            return (
              <SubButton
                className="font-paragraph"
                key={item.id}
                aria-hidden="true"
                onClick={() => {
                  if (item.onClick) {
                    item.onClick();
                  }
                  setIsShow(false);
                }}
              >
                {item.icon}
                {item.text}
              </SubButton>
            );
          })}
        </Wrapper>
      </ClickOut>
    );
  }

  return <div />;
};

export default Index;
